(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function bus() {
    return window.eventBus || null;
  }

  var addonVariantSet = null;
  var CAT_ATTR = {
    confect: 'Confectionary',
    wine: 'Wine',
    bears: 'Bears',
    candles: 'Candles'
  };
  var ALL_ATTR = 'Going with the flowers';
  var CAT_KEYS = Object.keys(CAT_ATTR).map(function (k) { return CAT_ATTR[k]; });

  function loadAddonVariantSet() {
    if (addonVariantSet) return addonVariantSet;
    addonVariantSet = {};
    var el = document.getElementById('bc-addon-variant-ids');
    if (el) {
      try {
        var ids = JSON.parse(el.textContent);
        (ids || []).forEach(function (id) { addonVariantSet[String(id)] = true; });
      } catch (e) {}
    }
    qsa('[data-bc-add]').forEach(function (btn) {
      var id = btn.getAttribute('data-bc-add');
      if (id) addonVariantSet[String(id)] = true;
    });
    return addonVariantSet;
  }

  function lineCat(item) {
    var props = (item && item.properties) || {};
    var c = props._bc_addon_cat || props['_bc_addon_cat'] || '';
    if (c) return c;
    return '';
  }

  function isAddonLine(item) {
    var set = loadAddonVariantSet();
    var props = (item && item.properties) || {};
    if (props._bc_addon || props['_bc_addon']) return true;
    return !!(item && set[String(item.variant_id || item.id)]);
  }

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        var fmt = (window.theme && theme.moneyFormat) || (window.wetheme && wetheme.moneyFormat) || '${{amount}}';
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function imageUrl(item) {
    if (!item || !item.image) return '';
    var src = item.image;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_100x100$1$2');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function labelForItem(item) {
    var title = item.product_title || item.title || 'Item';
    if (item.quantity > 1) title += ' × ' + item.quantity;
    return title;
  }

  function renderInGift(cart) {
    var items = (cart && cart.items) || [];
    var addons = items.filter(isAddonLine);
    var roots = qsa('[data-bc-in-gift]');
    roots.forEach(function (root) {
      var list = qs('[data-bc-in-gift-list]', root);
      if (!list) return;
      if (!addons.length) {
        root.hidden = true;
        list.innerHTML = '';
        return;
      }
      root.hidden = false;
      list.innerHTML = addons.map(function (item) {
        var img = imageUrl(item);
        var qty = item.quantity > 1 ? (' × ' + item.quantity) : '';
        return (
          '<div class="bc-in-gift__row" data-line-key="' + String(item.key).replace(/"/g, '') + '">' +
            '<div class="bc-in-gift__img">' + (img ? '<img src="' + img + '" alt="" width="48" height="48" loading="lazy">' : '') + '</div>' +
            '<div>' +
              '<p class="bc-in-gift__name">' + escapeHtml(item.product_title || item.title) + '</p>' +
              '<p class="bc-in-gift__meta">' + money(item.final_line_price || item.line_price) + qty + '</p>' +
            '</div>' +
            '<button type="button" class="bc-in-gift__remove" data-bc-remove="' + String(item.key).replace(/"/g, '') + '">Remove</button>' +
          '</div>'
        );
      }).join('');
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // Cart attributes + real line items (Zapiet / order prints read both)
  function syncAddonAttributes(cart) {
    var items = ((cart && cart.items) || []).filter(isAddonLine);
    var byCat = { confect: [], wine: [], bears: [], candles: [], other: [] };
    items.forEach(function (item) {
      var cat = lineCat(item) || 'other';
      if (!byCat[cat]) byCat[cat] = [];
      byCat[cat].push(labelForItem(item));
    });

    var existing = Object.assign({}, (cart && cart.attributes) || {});
    // Clear our managed keys first
    delete existing[ALL_ATTR];
    CAT_KEYS.forEach(function (k) { delete existing[k]; });

    var allLabels = items.map(labelForItem);
    if (allLabels.length) existing[ALL_ATTR] = allLabels.join(', ');

    Object.keys(CAT_ATTR).forEach(function (cat) {
      var labels = byCat[cat] || [];
      if (labels.length) existing[CAT_ATTR[cat]] = labels.join(', ');
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: existing })
    }).then(function (r) {
      if (!r.ok) throw new Error('addon attributes failed');
      return r.json();
    }).then(function () {
      return fetchCart();
    });
  }

  function refreshInGiftAndAttrs() {
    mountDrawers();
    addonVariantSet = null;
    loadAddonVariantSet();
    return fetchCart()
      .then(function (cart) {
        renderInGift(cart);
        return syncAddonAttributes(cart);
      })
      .then(function (cart) {
        renderInGift(cart);
        return cart;
      })
      .catch(function (err) {
        console.warn('[Birdcage add-ons] refresh', err);
      });
  }


  var NUDGE_KEY = 'bc_addon_nudge_seen_v3';

  function mountNudge() {
    var nudge = qs('[data-bc-nudge]');
    if (!nudge) return;
    if (nudge.parentNode !== document.body) document.body.appendChild(nudge);
  }

  function closeNudge() {
    var nudge = qs('[data-bc-nudge]');
    if (nudge) nudge.hidden = true;
    document.body.classList.remove('bc-nudge-open');
  }

  function markNudgeSeen() {
    try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch (e) {}
  }

  function nudgeAlreadySeen() {
    try { return sessionStorage.getItem(NUDGE_KEY) === '1'; } catch (e) { return false; }
  }

  function cartHasAddons(cart) {
    return ((cart && cart.items) || []).some(isAddonLine);
  }

  function showNudgeIfNeeded(cart) {
    if (/\/cart\/?$/.test(window.location.pathname)) return;
    if (nudgeAlreadySeen()) return;
    if (!cart || !cart.item_count) return;
    if (cartHasAddons(cart)) return;
    var nudge = qs('[data-bc-nudge]');
    if (!nudge) {
      console.warn('[Birdcage add-ons] nudge element missing');
      return;
    }
    mountNudge();
    nudge.hidden = false;
    /* no body lock */
    // Do not mark seen until dismiss/browse — avoids "shown behind drawer" locking it out
  }

  function browseFromNudge() {
    markNudgeSeen();
    closeNudge();
    var drawer = qs('cart-drawer');
    var target = qs('cart-drawer .bc-addons') || qs('.bc-addons-cart-wrap .bc-addons') || qs('.bc-addons');
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      var scrollEl = qs('[data-cart-scroll-element]', drawer) || drawer;
      if (target && scrollEl && target.closest('cart-drawer')) {
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e) {
          scrollEl.scrollTop = Math.max(0, target.offsetTop - 40);
        }
      }
    } else if (target) {
      try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {
        target.scrollIntoView(true);
      }
    }
    if (target) {
      target.classList.add('bc-addons--pulse');
      setTimeout(function () { target.classList.remove('bc-addons--pulse'); }, 1600);
    }
  }

  var __bcNudgeTimer = null;
  function maybeNudgeFromCartOpen() {
    if (__bcNudgeTimer) clearTimeout(__bcNudgeTimer);
    __bcNudgeTimer = setTimeout(function () {
      fetchCart().then(function (cart) {
        showNudgeIfNeeded(cart);
      }).catch(function () {});
    }, 700);
  }

  function mountDrawers() {
    var seen = {};
    qsa('[data-bc-drawer]').forEach(function (d) {
      var key = d.getAttribute('data-bc-drawer');
      if (seen[key]) {
        if (d.parentNode) d.parentNode.removeChild(d);
        return;
      }
      seen[key] = true;
      document.body.appendChild(d);
    });
  }

  function openDrawer(key) {
    var drawer = qs('[data-bc-drawer="' + key + '"]');
    if (!drawer) return;
    drawer.hidden = false;
    drawer.removeAttribute('hidden');
    drawer.style.display = 'flex';
    document.body.classList.add('bc-drawer-open');
    var closeBtn = qs('[data-bc-close]', drawer);
    try { if (closeBtn) closeBtn.focus({ preventScroll: true }); } catch (e) { if (closeBtn) closeBtn.focus(); }
  }

  function closeDrawers() {
    qsa('[data-bc-drawer]').forEach(function (d) {
      d.hidden = true;
      d.setAttribute('hidden', '');
      d.style.display = '';
    });
    document.body.classList.remove('bc-drawer-open');
  }

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  function updateThemeCart(responseJson) {
    var eb = bus();
    if (eb) {
      try { eb.emit('update:cart:drawer', responseJson); } catch (e) {}
      try { eb.emit('cart:added', {}); } catch (e) {}
      try { eb.emit('open:cart:drawer', { scrollToTop: true }); } catch (e) {}
    }
    if (eb && !(responseJson && responseJson.sections && responseJson.sections['cart-drawer'])) {
      try { eb.emit('render:cart:drawer'); } catch (e) {}
    }
    fetchCart().then(function (cart) {
      if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
        window.wetheme.updateCartCount(cart);
      } else {
        var count = cart.item_count;
        qsa('[data-cart-count-indicator], [data-cart-count], .cart-count').forEach(function (el) {
          el.textContent = String(count);
          el.classList.remove('hide', 'hidden');
          if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
        });
      }
      renderInGift(cart);
      return syncAddonAttributes(cart);
    }).catch(function () {});
  }

  function addVariant(id, btn, cat) {
    if (!id) return;
    btn.classList.add('is-busy');
    btn.disabled = true;
    btn.textContent = '…';

    var props = { _bc_addon: '1' };
    if (cat) props._bc_addon_cat = cat;

    var payload = {
      items: [{
        id: Number(id),
        quantity: 1,
        properties: props
      }],
      sections: 'cart-drawer'
    };

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (err) {
            var msg = (err && (err.description || err.message)) || ('add failed ' + r.status);
            throw new Error(msg);
          });
        }
        return r.json();
      })
      .then(function (responseJson) {
        closeDrawers();
        updateThemeCart(responseJson);
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.disabled = false;
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.textContent = 'Add';
        }, 1600);
      })
      .catch(function (err) {
        console.error('[Birdcage add-ons]', err);
        btn.classList.remove('is-busy');
        btn.disabled = false;
        btn.textContent = 'Retry';
      });
  }

  function removeLine(key, btn) {
    if (!key) return;
    if (btn) {
      btn.disabled = true;
      btn.textContent = '…';
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: 0, sections: 'cart-drawer' }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('remove failed');
        return r.json();
      })
      .then(function (responseJson) {
        var eb = bus();
        if (eb) {
          try { eb.emit('update:cart:drawer', responseJson); } catch (e) {}
          try { eb.emit('render:cart:drawer'); } catch (e) {}
        }
        return refreshInGiftAndAttrs().then(function (cart) {
          if (cart && window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
            window.wetheme.updateCartCount(cart);
          }
        });
      })
      .catch(function (err) {
        console.error('[Birdcage add-ons] remove', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Remove';
        }
      });
  }


  function bindEventBus() {
    var eb = bus();
    if (!eb || typeof eb.on !== 'function') return false;
    if (window.__bcAddonBusBound) return true;
    window.__bcAddonBusBound = true;
    try { eb.on('cart:added', refreshInGiftAndAttrs); } catch (e) {}
    try { eb.on('update:cart:drawer', refreshInGiftAndAttrs); } catch (e) {}
    try { eb.on('open:cart:drawer', maybeNudgeFromCartOpen); } catch (e) {}
    try {
      eb.on('drawer:opened', function (el) {
        if (el && el.tagName && String(el.tagName).toLowerCase() === 'cart-drawer') {
          maybeNudgeFromCartOpen();
        }
      });
    } catch (e) {}
    return true;
  }

  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || window.__bcAddonDrawerWatch) return;
    window.__bcAddonDrawerWatch = true;
    var obs = new MutationObserver(function () {
      var open = drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('open');
      if (open) maybeNudgeFromCartOpen();
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  }

  // Bag / cart icon clicks (no case-insensitive attr selectors — they break closest())
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var bag = t.closest('a[href="/cart"], a[href$="/cart"], [aria-controls="CartDrawer"], .shopping-bag, .cart-count-enabled');
    if (!bag) return;
    setTimeout(maybeNudgeFromCartOpen, 900);
  }, true);

  function init() {
    mountDrawers();
    mountNudge();
    loadAddonVariantSet();
    refreshInGiftAndAttrs();
    if (!bindEventBus()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (bindEventBus() || tries > 40) clearInterval(timer);
      }, 250);
    }
    watchCartDrawer();
    setTimeout(watchCartDrawer, 1000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshInGiftAndAttrs();
    });
    /* /cart page: tiles already shown — do not open reminder overlay */
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-bc-open]');
    if (open) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(open.getAttribute('data-bc-open'));
      return;
    }
    if (e.target.closest('[data-bc-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawers();
      return;
    }
    var add = e.target.closest('[data-bc-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      addVariant(add.getAttribute('data-bc-add'), add, add.getAttribute('data-bc-cat') || '');
      return;
    }
    var rem = e.target.closest('[data-bc-remove]');
    if (rem) {
      e.preventDefault();
      e.stopPropagation();
      removeLine(rem.getAttribute('data-bc-remove'), rem);
      return;
    }
    if (e.target.closest('[data-bc-nudge-browse]')) {
      e.preventDefault();
      e.stopPropagation();
      browseFromNudge();
      return;
    }
    if (e.target.closest('[data-bc-nudge-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeNudge();
      markNudgeSeen();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeNudge(); }
  });
})();
